// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-19T18:12:21.929Z
// Property: Creekside Apartments (ID: 6767906449167025)
// Collections: 21 amenities, 9 floorplans (live), 17 photos, 39 POIs, 8 reviews, 4 virtual tours, 4 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162417",
  "multihub_property_id": "6767906449167025",
  "property_external_id": "1200076",
  "property_zillow_url": "https://www.zillow.com/apartments/vista-ca/creekside-apartments/CkCPYz/",
  "property_apartments_url": "https://www.apartments.com/creekside-apartments-vista-ca/c8r966g/",
  "property_google_business_url": "https://www.google.com/maps/place/Creekside+Apartments/data=!4m2!3m1!1s0x0:0x62c9cebdd9f9e2e0?sa=X&ved=2ahUKEwjhgPrT1f6SAxX0EkQIHbpKCVYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "42176974715",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": "Entrata ",
  "property_status": null,
  "property_slug": "vista-creekside",
  "property_name": "Creekside Apartments",
  "property_website_url": "https://www.creeksideapartmentsvista.com/",
  "property_domain": "https://www.creeksideapartmentsvista.com/",
  "property_address": "215 Vista Village Dr",
  "property_full_address": "215 Vista Village Dr, Vista, CA 92083",
  "property_address_1": "215 Vista Village Dr",
  "property_address_2": null,
  "property_address_city": "Vista",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "92083",
  "property_address_country": "US",
  "property_address_county": "San Diego County",
  "property_neighborhood_address": "Vista",
  "property_address_latitude": "33.1985428",
  "property_address_longitude": "-117.2464952",
  "property_email": "creeksideapartments@sunrisemgmt.com",
  "property_phone": "(760) 625-0841",
  "property_call_tracking_phone": "760-625-0841",
  "property_company_name": "Sunrise Management",
  "property_company_url": "https://www.sunrisemgmt.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to Creekside, a modern apartment community surrounded by a natural creek in the center of the vibrant Vista Village Retail Center. Creekside offers the perfect atmosphere for luxury living within a walkable community. You&rsquo;ll find",
  "property_long_description": "Welcome to Creekside, a modern apartment community surrounded by a natural creek in the center of the vibrant Vista Village Retail Center. Creekside offers the perfect atmosphere for luxury living within a walkable community. You&rsquo;ll find your ideal apartment home among our spacious studio, one, and two-bedroom floor plan options. Apartments feature quartz countertops, wood-style plank flooring, sleek cabinetry, and an in-home washer and dryer that will elevate your lifestyle. Select apartments also include serene creek views and private balconies.\r\nEnjoy a central location in North County San Diego just minutes away from beautiful beaches and quick access to the 78 and the 5 Freeway putting everything in North County to downtown San Diego at your fingertips. Residents can also walk to a grocery store, dozens of retailers, a Cinepolis movie theater and a Wave water park.If this sounds like your ideal community, then visit our luxury apartments in Vista, CA, for rent today and get a tour of your future home.\r\n\r\nSan Diego Sunrise Management Co. dba Sunrise Management | Lic. No. 00927850 | Broker: Joseph S. Greenblatt License number 01064415",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba37-db9f-720c-b688-2e0c56482efa.webp",
  "property_featured_image_media": {
    "alt_text": "A serene courtyard with a stream, bridge, and lush greenery, offering a peaceful outdoor escape.",
    "public_id": "019eba37-db9f-720c-b688-2e0c56482efa",
    "storage_key": "property/6767906449167025/019eba37-db9f-720c-b688-2e0c56482efa.webp",
    "width": 2048,
    "height": 1151
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167025/019f487d-e2c3-74e8-afdf-e4f8dca643a2.mp4",
  "property_featured_video_media": {
    "public_id": "019f487d-e2c3-74e8-afdf-e4f8dca643a2",
    "storage_key": "property/6767906449167025/019f487d-e2c3-74e8-afdf-e4f8dca643a2.mp4",
    "thumbnail_key": "property/6767906449167025/019f487d-e2c3-74e8-afdf-e4f8dca643a2_thumb.webp",
    "size_bytes": 69228922,
    "classification": "Community",
    "title": "Discover Tranquil Living: Community and Apartment Highlights",
    "description": "Explore the serene surroundings, modern apartment interiors, and vibrant lifestyle amenities that define this exceptional property. Your new home awaits."
  },
  "property_total_units": "33",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": "82",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "87.87878787878788",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": "Security deposit: $250.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "100",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "30",
  "property_pet_restrictions": "Maximum of 2 pets per unit. Maximum weight: 75 lbs.",
  "property_pet_policy_description": "Pet deposit: $500.00 (refundable). Monthly pet rent: $50.00/month.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dog\nMax Number of Pets: 2\nMax weight of pets: 30 lbs\nPet deposit fee min: $500\nPet monthly rent min: $50\nPet policy fee min/max: $50 - $100",
  "property_online_leasing_url": "https://creeksideapartmentsvista.prospectportal.com/Vista/Creekside Apartments",
  "property_resident_portal_url": "https://creeksideapartmentsvista.residentportal.com/auth",
  "property_apply_now_url": "https://creeksideapartmentsvista.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/1200076/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019e98bf-ede4-7572-9613-b9f67a38b5f6.webp",
  "property_primary_logo_media": {
    "alt_text": "Creekside Apartments logo",
    "public_id": "019e98bf-ede4-7572-9613-b9f67a38b5f6",
    "storage_key": "property/6767906449167025/019e98bf-ede4-7572-9613-b9f67a38b5f6.webp",
    "width": 2525,
    "height": 392
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019e8e56-c7fa-7753-9265-491330e6b851.webp",
  "property_icon_media": {
    "alt_text": "Outdoor swimming pool with blue water and white clouds in the sky",
    "public_id": "019e8e56-c7fa-7753-9265-491330e6b851",
    "storage_key": "property/6767906449167025/019e8e56-c7fa-7753-9265-491330e6b851.webp",
    "width": 28,
    "height": 28
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019e98c0-2927-75ca-bf9c-092c049f4905.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Creekside Apartments logo",
    "public_id": "019e98c0-2927-75ca-bf9c-092c049f4905",
    "storage_key": "property/6767906449167025/019e98c0-2927-75ca-bf9c-092c049f4905.webp",
    "width": 1280,
    "height": 198
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019e98c0-1ade-711a-ad16-43ee10179df9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Creekside Apartments logo",
    "public_id": "019e98c0-1ade-711a-ad16-43ee10179df9",
    "storage_key": "property/6767906449167025/019e98c0-1ade-711a-ad16-43ee10179df9.webp",
    "width": 1280,
    "height": 198
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-ae4d-75a8-a6aa-7bc8aa917e90.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
  "property_company_logo_media": {
    "alt_text": "Sunrise Management logo",
    "public_id": "019d06cf-4134-73f9-aa2c-2cbcff86a11a",
    "storage_key": "company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "width": 256,
    "height": 256
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-016c-71e4-a66c-b5d1e83b79cb.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-0100-7115-9635-6815428ea63d.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#5a3b2e",
  "property_secondary_color": "#f7f5f2",
  "property_font_color": "#50372a",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "480 - 954",
  "property_sqft_min": "480",
  "property_sqft_max": "954",
  "property_price_range": "$2179 - $3129",
  "property_price_min": "2179",
  "property_price_max": "3129",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/creeksideapartmentsvista/",
  "property_instagram_url": "https://www.instagram.com/creekside_apartments215/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPbIDQ5t33IAR4OL52b3OyWI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Creekside Apartments",
  "property_home_romance_title": "Embrace Your New Adventure at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Creekside Apartments in Vista, CA, where modern living meets nature's tranquility. Choose from stylish studio, one, or two-bedroom layouts, each with premium finishes. Indulge in creek views, outdoor lounges, and a vibrant clubhouse, all just moments from delightful dining and the Pacific Ocean. Your serene escape awaits!",
  "property_home_floorplans_blurb": "At Creekside Apartments in scenic Vista, CA, your ideal home awaits! With thoughtfully designed studio, one-bedroom, and two-bedroom layouts, there’s something to suit every lifestyle. Unwind in our inviting community and enjoy serene surroundings. Browse our available apartment homes today and find the perfect floor plan tailored to you!",
  "property_home_gallery_blurb": "At Creekside Apartments in Vista, CA, lifestyle meets luxury. Choose from studio to two-bedroom layouts surrounded by picturesque creek views, lush courtyards, and serene walking trails. Enjoy premium amenities like a resident clubhouse, outdoor living spaces, and 24-hour maintenance, all just moments from fine dining and shopping. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Creekside Apartments, where modern living meets vibrant community life in Vista, CA. Immerse yourself in a neighborhood rich with attractions like the serene Alga Norte Community Park, the excitement of Boomers Vista, and the nearby educational hubs of Palomar College and the University of St. Augustine. Enjoy the perfect blend of comfort and convenience!",
  "property_home_reviews_blurb": "At Creekside Apartments in Vista, CA, residents rave about the serene atmosphere and supportive community. With a 5.0 rating, one resident shares, \"I love living here! Dog friendly, good neighbors, quiet.\" Immerse yourself in a lifestyle where safety and comfort come together. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in scenic Vista, CA, Creekside Apartments perfectly blend comfort with convenience. Embrace a vibrant lifestyle surrounded by exceptional amenities like Alga Norte Community Park, Frontwave Arena, and the dynamic offerings of The Shoppes at Carlsbad. Your new home awaits, with adventure just beyond your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Creekside Apartments in Vista, CA, indulge in a vibrant lifestyle with premium amenities like a resident clubhouse, outdoor living areas, and serene creek views. Enjoy modern finishes, energy-efficient appliances, and access to scenic walking trails—all just minutes from dining, shopping, and the beach. Elevate your living experience today!",
  "property_applynow_blurb": "At Creekside Apartments in Vista, CA, luxurious living meets nature's charm. Choose from stylish studios to spacious two-bedroom layouts featuring creek views. Enjoy premium amenities like a resident clubhouse, bocce ball court, and serene walking trails. Experience effortless leisure just minutes from dining, shopping, and the Pacific Ocean. Lease online today!",
  "property_contactus_blurb": "At Creekside Apartments in Vista, CA, your ideal home awaits. Choose from stylish studio, one-bedroom, and two-bedroom floor plans designed for comfort and convenience. Have questions or need guidance? Our dedicated leasing team is here to help—reach out today and let us assist you in finding your perfect space!",
  "property_faqs_blurb": "At Creekside Apartments in Vista, CA, we offer a range of floor plans—studio, one-bedroom, and two-bedroom—to suit every lifestyle. Curious about living here? Our FAQs page is your go-to resource for insights into our vibrant community and amenities. Dive in to find the answers you seek!",
  "property_floorplans_blurb": "At Creekside Apartments in Vista, CA, we offer an array of thoughtfully designed floor plans to suit your lifestyle. Whether you're seeking a cozy studio, a spacious one-bedroom, or a luxurious two-bedroom, our homes blend comfort with modern living. Browse our available apartment options and find your perfect fit today!",
  "property_gallery_blurb": "Welcome to Creekside Apartments in beautiful Vista, CA, where premium design meets serene creek views. Imagine unwinding in your spacious one- or two-bedroom oasis, enjoying outdoor living areas, and exploring nearby dining and shopping. Capture every moment—browse our photo gallery and envision your ideal lifestyle among picturesque landscapes!",
  "property_interactivemap_blurb": "At Creekside Apartments in Vista, CA, choose from stylish studios to spacious two-bedroom layouts, each featuring modern designs and serene views. Enjoy our resident clubhouse, outdoor living spaces, and peaceful creekside trails. With top-notch amenities and proximity to shopping, dining, and attractions, your dream lifestyle awaits. Explore our interactive community map to find your perfect home!",
  "property_pets_blurb": "At Creekside Apartments in Vista, CA, your furry friends are family! With a welcoming pet policy for cats and dogs up to 35 pounds, our community offers the perfect backdrop for playful adventures and cozy cuddles. Experience apartment living where both you and your pets can thrive together.",
  "property_referafriend_blurb": "At Creekside Apartments in scenic Vista, CA, great friendships blossom among our studio, one-bedroom, and two-bedroom floor plans. Bring your friends along to share the vibrant community life we cherish. Great friends make great neighbors—refer a friend today and grow your circle in a perfect home!",
  "property_residentaccess_blurb": "Welcome to Creekside Apartments in scenic Vista, CA, where stylish living meets convenience. Enjoy thoughtfully designed floor plans, from cozy studios to spacious two-bedrooms. Access your resident portal for easy rent payments, maintenance requests, and additional services to enhance your living experience. Your comfort awaits!",
  "property_reviews_blurb": "At Creekside Apartments in Vista, CA, residents thrive in a dog-friendly, peaceful environment surrounded by friendly neighbors. One delighted resident said, “I love living here!” with easy access to vibrant downtown bars and restaurants. Curious about our community? See what our residents have to say about living at Creekside!",
  "property_created_at": "1770052363777",
  "property_scheduletour_blurb": "At Creekside Apartments in Vista, CA, your ideal home awaits! Choose from spacious studio, one-bedroom, or two-bedroom floor plans designed for comfort and style. Ready to take the next step? Schedule a tour today and see why our residents love calling Creekside their home sweet home!",
  "property_thankyou_blurb": "Thank you for reaching out to Creekside Apartments in picturesque Vista, CA. Our diverse floor plans, including cozy studios and spacious one and two-bedroom layouts, offer the perfect blend of comfort and style. A team member will be in touch soon to help you find your ideal home!",
  "property_virtualtours_blurb": "Step into the charm of Creekside Apartments in Vista, CA, where home meets comfort. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom layouts, perfect for any lifestyle. Immerse yourself in our vibrant community—take a virtual tour today and envision your new beginning!",
  "property_copyright": "2026 All Rights Reserved. Vista Creekside ",
  "property_seo_title_home": "Creekside Apartments |  Apartments in Vista, CA",
  "property_seo_description_home": "Experience luxury living at Creekside Apartments in Vista, CA. Enjoy creek views, stylish layouts, vibrant amenities, and nearby dining.",
  "property_seo_title_floorplans": "Floor Plans | Vista, CA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Creekside Apartments in Vista, CA! Stylish studios and one/two-bedroom layouts await—explore our floor plans!",
  "property_seo_title_amenities": "Amenities | Vista, CA Apartments for Rent",
  "property_seo_description_amenities": "Discover Creekside Apartments in Vista, CA! Enjoy creek views, top amenities, and easy access to shopping and the ocean. Join our community!",
  "property_seo_title_gallery": "Gallery | Apartments in Vista, CA",
  "property_seo_description_gallery": "Imagine life at Creekside Apartments in Vista, CA! With stunning creek views, premium amenities, and a vibrant community, your dream home awaits!🌿✨",
  "property_seo_title_virtualtours": "Virtual Tours | Creekside Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Creekside Apartments in Vista, CA. Take a virtual tour today and find your perfect studio, one-bedroom, or two-bedroom home!",
  "property_seo_title_interactivemap": "Interactive Map | Creekside Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Creekside Apartments, Vista, CA! Enjoy stylish living, creek views, and a vibrant community near dining and shopping.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Vista, CA",
  "property_seo_description_neighborhood": "Experience Vista living at Creekside Apartments! Uncover local favorites and explore nearby attractions that make our community a vibrant place to call home.",
  "property_seo_title_contact": "Contact Us | Creekside Apartments",
  "property_seo_description_contact": "Connect with us at Creekside Apartments in Vista, CA! From cozy studios to spacious two-bedrooms, our leasing team is ready to answer your questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in Vista, CA",
  "property_seo_description_faqs": "Find answers to your questions at Creekside Apartments! Learn about our studio to two-bedroom layouts, amenities, and life in Vista, CA, surrounded by nature.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Vista, CA",
  "property_seo_description_reviews": "Discover why Creekside Apartments is loved! Enjoy stunning creek views, modern amenities, and joyful resident experiences in Vista, CA.",
  "property_seo_title_applynow": "Apply Now | Apartments in Vista, CA",
  "property_seo_description_applynow": "Experience elevated living at Creekside Apartments in Vista, CA. Enjoy stylish homes, serene creek views, and top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Creekside Apartments",
  "property_seo_description_residentaccess": "Stay connected at Creekside Apartments in Vista, CA. Log in to your resident portal for easy rent payments, maintenance requests, and essential updates!",
  "property_seo_title_referafriend": "Refer A Friend | Creekside Apartments",
  "property_seo_description_referafriend": "Refer a friend to Creekside Apartments in Vista, CA! Share the joy of our vibrant community where great friends make the best neighbors. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Creekside Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Creekside Apartments in Vista, CA. Schedule a tour today and find your perfect home nestled among tranquil surroundings!",
  "property_seo_title_privacy": "Privacy Policy | Creekside Apartments",
  "property_seo_description_privacy": "Your privacy matters at Creekside Apartments in Vista, CA. Uncover our commitment to safeguarding your information. View our privacy policy for full details.",
  "property_seo_title_accessibility": "Website Accessibility | Creekside Apartments",
  "property_seo_description_accessibility": "At Creekside Apartments in Vista, CA, we prioritize accessibility for all. Join us in creating an inclusive community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Creekside Apartments",
  "property_seo_description_sitemap": "Uncover a vibrant lifestyle at Creekside Apartments in Vista, CA. Navigate our sitemap to find the perfect home and amenities that suit your needs!",
  "property_seo_title_thankyou": "Thank You | Creekside Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Creekside Apartments in Vista, CA! Our team will connect with you soon to assist you in finding your ideal home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Vista, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293655016",
  "amenities": [
    {
      "id": "custom_02495187-8f05-4106-a4f2-add267c8cc17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f3d69e0-0e21-428a-b69e-203b932ac10a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Living Areas",
      "amount": "false",
      "description": "with BBQ grills and gathering spaces",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2abc0be-1fd2-40b8-b755-77dfe721cb73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Creek Views",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59716868-c58c-4548-a3a2-b4aa5e793f3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "24‑hour emergency maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2034d00a-84a6-450f-80ca-275b9c6e4023",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Close to fine dining, breweries and shopping including the Carlsbad Premium outlets",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64d1bc1d-c682-427b-b0c7-f7a898c31207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Direct access to creek featuring mature landscape and walking trails",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6fc47ff4-3422-463e-9c25-c6b9e04598a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke‑free community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18a81118-a385-40d5-9394-dfc5c8f774df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Detached garages available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6b693c3-26e7-46b0-9c69-08c5bf6fa969",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Premium design finishes",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2db0c06-0623-4fbc-b92b-677e8bb398e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary WiFi in common areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27d28e84-a152-4c94-9ffe-d08484d1e3e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Close proximity to the Pacific Ocean, Legoland, Wild Animal Safari Park, and The Wave Water Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_634048ab-6bf9-43a8-b4d3-960a38dedfdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Creek & water park views*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f67e8d6a-48ec-4245-8377-37fae8fa682d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally landscaped courtyards",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92fa0c2e-9099-4705-ae84-64a121b2ac60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Bocce Ball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd7ece27-b694-4cc0-a8f8-5c176886cef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home washer/dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfa6287e-865a-438f-b7af-22b2c73317aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless steel appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab9f70be-9b8e-4b55-aeb7-38a168a20f7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-style flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e676c271-cd9a-45cf-8bb9-bfb1a854f3fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Large windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc4ee805-0b41-40d1-a2c7-882ca87cb375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Large closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a48e4a87-b27a-4928-b30b-f829f940b753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Patios/ balconies*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbc8df3c-25c1-4580-bf9c-26dc8a673e8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "external_id": "false",
      "title": "Carport/Garage parking",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ef8a87c9a27a1b5cc6ac4714",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-2305-7459-92eb-dc488031db70.webp",
      "image_media": {
        "alt_text": "Comfortable lounge area with a large sectional sofa and TV, adjacent to a communal dining table with chairs.",
        "public_id": "019eba85-2305-7459-92eb-dc488031db70",
        "storage_key": "property/6767906449167025/019eba85-2305-7459-92eb-dc488031db70.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Community Room",
      "link": "false",
      "alt_text": "Community Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053022/6a29f38d9e5185.15440138313.jpg"
    },
    {
      "id": "ec_d7731c2b53afc48df42ff8cd",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-1f92-74f4-8e76-cabc0b209297.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and washer/dryer",
        "public_id": "019eba85-1f92-74f4-8e76-cabc0b209297",
        "storage_key": "property/6767906449167025/019eba85-1f92-74f4-8e76-cabc0b209297.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Bedroom",
      "link": "false",
      "alt_text": "Bedroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053023/6a29f38ea78f80.36126391882.jpg"
    },
    {
      "id": "ec_8bb538a8e610865dc836d1cc",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-1fe0-75b3-a024-d0127ee2f772.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and light wood flooring.",
        "public_id": "019eba85-1fe0-75b3-a024-d0127ee2f772",
        "storage_key": "property/6767906449167025/019eba85-1fe0-75b3-a024-d0127ee2f772.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Living Room",
      "link": "false",
      "alt_text": "Living Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053024/6a29f38f9d7300.58917999934.jpg"
    },
    {
      "id": "ec_53cce82ea3c24c1fd4ef4ad0",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-236d-752d-b705-0ef8fb89ee79.webp",
      "image_media": {
        "alt_text": "Covered parking garage with multiple individual garage bays and parked cars.",
        "public_id": "019eba85-236d-752d-b705-0ef8fb89ee79",
        "storage_key": "property/6767906449167025/019eba85-236d-752d-b705-0ef8fb89ee79.webp",
        "width": 2500,
        "height": 1664
      },
      "title": "Community",
      "description": "Garage",
      "link": "false",
      "alt_text": "Garage",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053012/6a29f3845d7cd6.54204673260.jpg"
    },
    {
      "id": "ec_cdd33cb298431b193867958e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-2e03-7249-8579-654993a4d068.webp",
      "image_media": {
        "alt_text": "Tranquil stream with ducks flowing through a landscaped courtyard with a pedestrian bridge in the background.",
        "public_id": "019eba85-2e03-7249-8579-654993a4d068",
        "storage_key": "property/6767906449167025/019eba85-2e03-7249-8579-654993a4d068.webp",
        "width": 2500,
        "height": 1405
      },
      "title": "Community",
      "description": "Creek",
      "link": "false",
      "alt_text": "Creek",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053013/6a29f3856a0493.15822420513.jpg"
    },
    {
      "id": "ec_6b12fce9ee014334f1d9b9b9",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-4186-7709-8051-09bbfc01bc80.webp",
      "image_media": {
        "alt_text": "Apartment buildings at dusk with a colorful sky and landscaped grounds.",
        "public_id": "019eba85-4186-7709-8051-09bbfc01bc80",
        "storage_key": "property/6767906449167025/019eba85-4186-7709-8051-09bbfc01bc80.webp",
        "width": 2500,
        "height": 1405
      },
      "title": "Community",
      "description": "Sunset Exterior",
      "link": "false",
      "alt_text": "Sunset Exterior",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053014/6a29f3866c55e3.68189358236.jpg"
    },
    {
      "id": "ec_1234174bfd57022bbd12ec80",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-42b2-70f8-863e-eceeb6ff6a97.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large sectional sofa, ottoman, dining table, and chairs.",
        "public_id": "019eba85-42b2-70f8-863e-eceeb6ff6a97",
        "storage_key": "property/6767906449167025/019eba85-42b2-70f8-863e-eceeb6ff6a97.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Community Room",
      "link": "false",
      "alt_text": "Community Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053015/6a29f3874dda18.91051603822.jpg"
    },
    {
      "id": "ec_8856b02539cb250a2991d112",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-47c4-73cd-a7bc-1e6608c5694b.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with balconies overlooking a scenic walking path and creek.",
        "public_id": "019eba85-47c4-73cd-a7bc-1e6608c5694b",
        "storage_key": "property/6767906449167025/019eba85-47c4-73cd-a7bc-1e6608c5694b.webp",
        "width": 2500,
        "height": 1405
      },
      "title": "Community",
      "description": "Creekside Exterior",
      "link": "false",
      "alt_text": "Creekside Exterior",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053016/6a29f388503769.04280103101.jpg"
    },
    {
      "id": "ec_7a31a3e394663e4dcf216682",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-4cd9-75eb-96be-8594d17b7c60.webp",
      "image_media": {
        "alt_text": "Courtyard area with seating, fire pit, outdoor kitchen, and landscaping.",
        "public_id": "019eba85-4cd9-75eb-96be-8594d17b7c60",
        "storage_key": "property/6767906449167025/019eba85-4cd9-75eb-96be-8594d17b7c60.webp",
        "width": 2500,
        "height": 1405
      },
      "title": "Community",
      "description": "Courtyard",
      "link": "false",
      "alt_text": "Courtyard",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053017/6a29f3893b67f2.30630894588.jpg"
    },
    {
      "id": "ec_47079a3e500dc4f3a7e527ef",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-5966-766f-9091-059ed5bff36f.webp",
      "image_media": {
        "alt_text": "Spacious living area with large windows overlooking trees and a doorway to a bedroom and bathroom.",
        "public_id": "019eba85-5966-766f-9091-059ed5bff36f",
        "storage_key": "property/6767906449167025/019eba85-5966-766f-9091-059ed5bff36f.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Living Room",
      "link": "false",
      "alt_text": "Living Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053018/6a29f38a135ee5.59563767720.jpg"
    },
    {
      "id": "ec_4b38602fa18bc223065dcc51",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-632e-706a-a85c-6bfa8a219908.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white quartz countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019eba85-632e-706a-a85c-6bfa8a219908",
        "storage_key": "property/6767906449167025/019eba85-632e-706a-a85c-6bfa8a219908.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Kitchen",
      "link": "false",
      "alt_text": "Kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053019/6a29f38af3ea73.50758191585.jpg"
    },
    {
      "id": "ec_d2fe7e5294987a7569df44f5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-65d7-756f-bafe-956d445d02a3.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet, next to a room with a window.",
        "public_id": "019eba85-65d7-756f-bafe-956d445d02a3",
        "storage_key": "property/6767906449167025/019eba85-65d7-756f-bafe-956d445d02a3.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Laundry",
      "link": "false",
      "alt_text": "Laundry",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053020/6a29f38bdc88c8.38142048191.jpg"
    },
    {
      "id": "ec_dfbed86725268ab7b8164e72",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-6a85-768c-ad86-2821021359d6.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019eba85-6a85-768c-ad86-2821021359d6",
        "storage_key": "property/6767906449167025/019eba85-6a85-768c-ad86-2821021359d6.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Bathroom",
      "link": "false",
      "alt_text": "Bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053021/6a29f38cba2974.17478888650.jpg"
    },
    {
      "id": "ec_8719ef678b751ea9f7865225",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-7763-7629-9456-37893c0f8608.webp",
      "image_media": {
        "alt_text": "Empty living room with large windows and a balcony overlooking trees and buildings.",
        "public_id": "019eba85-7763-7629-9456-37893c0f8608",
        "storage_key": "property/6767906449167025/019eba85-7763-7629-9456-37893c0f8608.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Living Room",
      "link": "false",
      "alt_text": "Living Room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053025/6a29f3908623b0.10887771627.jpg"
    },
    {
      "id": "ec_6c296a842c76414b34ecfc6c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-7a32-740c-9f0e-1461a171e2b2.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white walls and shelving.",
        "public_id": "019eba85-7a32-740c-9f0e-1461a171e2b2",
        "storage_key": "property/6767906449167025/019eba85-7a32-740c-9f0e-1461a171e2b2.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Closet",
      "link": "false",
      "alt_text": "Closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053026/6a29f391806b98.13141788433.jpg"
    },
    {
      "id": "ec_454aa20ec583ea1805685ca4",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-825e-776b-8e37-02296eed293e.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark wood cabinets and stainless steel appliances.",
        "public_id": "019eba85-825e-776b-8e37-02296eed293e",
        "storage_key": "property/6767906449167025/019eba85-825e-776b-8e37-02296eed293e.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Apartment",
      "description": "Living/Dining",
      "link": "false",
      "alt_text": "Living/Dining",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053027/6a29f3929d26b1.51029764183.jpg"
    },
    {
      "id": "ec_66122a606f762833152888e8",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019eba85-87c6-7449-b5c4-751ae901feea.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit at sunset.",
        "public_id": "019eba85-87c6-7449-b5c4-751ae901feea",
        "storage_key": "property/6767906449167025/019eba85-87c6-7449-b5c4-751ae901feea.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Firepit",
      "link": "false",
      "alt_text": "Firepit",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/10/053028/6a29f3938fec14.52816674983.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1a85e62f-823b-43dd-b1c7-4f0a7656a6b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2735 Vista Way, Oceanside, CA 92054, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls with cinnamon butter. They highlight the generous portions, reasonable prices, and fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-da12-716f-9a74-809536fe153d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-da12-716f-9a74-809536fe153d",
        "storage_key": "property/6767906449167025/019d08bc-da12-716f-9a74-809536fe153d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/california/oceanside?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=11555436290976065709&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.1825273",
      "poi_longitude": "-117.327494",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 760-607-3535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dea-75e2-95c1-3f505ce55189",
        "storage_key": "property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3ohao9x3IARrShJVBUoXaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_befde98d-99dd-46a3-b979-881fd1858cd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "4605 Frazee Rd, Oceanside, CA 92057, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves fresh burgers and fries. They highlight the good value and fast service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-d98d-725f-b6bb-4abc5502a70c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-d98d-725f-b6bb-4abc5502a70c",
        "storage_key": "property/6767906449167025/019d08bc-d98d-725f-b6bb-4abc5502a70c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/162",
      "poi_directions_map_url": "https://maps.google.com/?cid=5177599221902216860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.2377811",
      "poi_longitude": "-117.2993315",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dea-75e2-95c1-3f505ce55189",
        "storage_key": "property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-r5-u5w3IARnA7Sag-H2kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e45f6406-9586-488c-868b-5ad1e9f9fdeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "The Red Chickz",
      "poi_type": "Restaurants",
      "poi_address": "2525 El Camino Real Unit 217, Carlsbad, CA 92008, USA",
      "poi_short_description": "Casual restaurant offering Nashville-style hot chicken, plus sides, shakes, and beer.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sandwiches, tenders, and sides like mac and cheese and potato wedges. They highlight the reasonable lunch specials, especially on weekdays, and the generous portions. They also like the friendly staff and the fun, upbeat vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-da32-70a0-b10c-d5ec302e63a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-da32-70a0-b10c-d5ec302e63a2",
        "storage_key": "property/6767906449167025/019d08bc-da32-70a0-b10c-d5ec302e63a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://theredchickz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1868830895028323864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-red-chickz",
      "poi_latitude": "33.1776411",
      "poi_longitude": "-117.3301935",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 760-717-0710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dea-75e2-95c1-3f505ce55189",
        "storage_key": "property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-GgL3tx3IARGEZwK8xr7xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4d236d97-c6d9-42d4-991f-ee31de691efc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3475 Marron Rd, Oceanside, CA 92056, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Diners say this chicken restaurant serves up great meals and offers fast and excellent service. They also highlight the fresh flowers on the tables and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-d7e1-7489-b3b5-d815dfcbb6cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-d7e1-7489-b3b5-d815dfcbb6cf",
        "storage_key": "property/6767906449167025/019d08bc-d7e1-7489-b3b5-d815dfcbb6cf.webp",
        "width": 1280,
        "height": 741
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/quarry-creek?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13130578240897458147&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.178046",
      "poi_longitude": "-117.294778",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 760-576-3128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dea-75e2-95c1-3f505ce55189",
        "storage_key": "property/6767906449167025/019d08bc-7dea-75e2-95c1-3f505ce55189.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93l7Jdxz3IAR458qYFcvObY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2f989e0c-03f3-466d-b551-595535dd62d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "The Shoppes at Carlsbad",
      "poi_type": "Shopping & Retail",
      "poi_address": "2525 El Camino Real, Carlsbad, CA 92008, USA",
      "poi_short_description": "Mall with chain stores for clothing & shoes, plus Macy's, JCPenney, several restaurants & a cinema.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and restaurants. They also highlight the convenient location, the spacious layout, and the welcoming atmosphere.\n\nOther reviews mention the mall can be quiet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-e122-7309-a0c3-51e4d69a9c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-e122-7309-a0c3-51e4d69a9c47",
        "storage_key": "property/6767906449167025/019d08bc-e122-7309-a0c3-51e4d69a9c47.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7058420090992305646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-carlsbad",
      "poi_latitude": "33.1782271",
      "poi_longitude": "-117.3324166",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 760-444-0620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dd9-760d-880b-a8e57d1c4ab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dd9-760d-880b-a8e57d1c4ab8",
        "storage_key": "property/6767906449167025/019d08bc-7dd9-760d-880b-a8e57d1c4ab8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEwz0D4lx3IAR7qUT96yL9GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_dc39fa40-cbbb-4928-8472-1536ede0a298",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2570 Vista Way, Oceanside, CA 92054, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and healthy food options, including seasonal items and ready-to-heat meals. They highlight the affordable prices and good value, as well as the clean and organized atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-e211-7511-9e4f-f8ebbe0511dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-e211-7511-9e4f-f8ebbe0511dd",
        "storage_key": "property/6767906449167025/019d08bc-e211-7511-9e4f-f8ebbe0511dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/oceanside/22/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18159414917863803080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.1841133",
      "poi_longitude": "-117.3319447",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 760-433-9994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-84af-77d9-a951-c3e032ccfbb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-84af-77d9-a951-c3e032ccfbb6",
        "storage_key": "property/6767906449167025/019d08bc-84af-77d9-a951-c3e032ccfbb6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwLb2Y1x3IARyIgztKczA_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e2b3f8a7-4fb6-4e86-841e-e9e459dd46a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3838 Vista Way, Oceanside, CA 92056, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a great inventory, friendly and helpful staff, and good prices. They also highlight the team spirit and willingness of the staff to go the extra mile to assist customers.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-e200-7580-a079-8020fa9c274b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-e200-7580-a079-8020fa9c274b",
        "storage_key": "property/6767906449167025/019d08bc-e200-7580-a079-8020fa9c274b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Oceanside/CA/Oceanside/92056/679?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12458933493880610540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.1852607",
      "poi_longitude": "-117.2947168",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 760-941-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7dd9-760d-880b-a8e57d1c4ab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7dd9-760d-880b-a8e57d1c4ab8",
        "storage_key": "property/6767906449167025/019d08bc-7dd9-760d-880b-a8e57d1c4ab8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR8_huWFx3IAR7F74ngAG56w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a010fcad-83f1-4230-a0dc-8f4ae24a23ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Palomar College",
      "poi_type": "Education",
      "poi_address": "1140 W Mission Rd, San Marcos, CA 92069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-2be0-7151-a51d-f2f016bd25a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-2be0-7151-a51d-f2f016bd25a6",
        "storage_key": "property/6767906449167025/019d08bc-2be0-7151-a51d-f2f016bd25a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.palomar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1114905682741900580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palomar-college",
      "poi_latitude": "33.1512505",
      "poi_longitude": "-117.1821885",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 760-744-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-84be-7582-8839-41f3c8829587",
        "storage_key": "property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJabtoixjm24ARJDXluc_weA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3bdaa5d5-35a3-40b6-86fc-be17de0c5b25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "MiraCosta College",
      "poi_type": "Education",
      "poi_address": "1 Barnard Dr, Oceanside, CA 92056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-2998-701d-9aa2-7fca7450bf16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-2998-701d-9aa2-7fca7450bf16",
        "storage_key": "property/6767906449167025/019d08bc-2998-701d-9aa2-7fca7450bf16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://miracosta.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8806364676229438337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miracosta-college",
      "poi_latitude": "33.1900734",
      "poi_longitude": "-117.302179",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 760-757-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-84be-7582-8839-41f3c8829587",
        "storage_key": "property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvSlrrrxx3IARgRs00QN-Nno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7cf3d630-0982-494c-aa2d-b11510b227e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "University of St. Augustine for Health Sciences - San Marcos, CA",
      "poi_type": "Education",
      "poi_address": "700 Windy Point Dr, San Marcos, CA 92069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-ec9a-7583-980a-3ba8c40f73c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-ec9a-7583-980a-3ba8c40f73c9",
        "storage_key": "property/6767906449167025/019d08bc-ec9a-7583-980a-3ba8c40f73c9.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.usa.edu/about/our-campuses/san-marcos-ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2252424877589988442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-st-augustine-for-health-sciences---san-marcos-ca",
      "poi_latitude": "33.1517392",
      "poi_longitude": "-117.1658851",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-241-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-84be-7582-8839-41f3c8829587",
        "storage_key": "property/6767906449167025/019d08bc-84be-7582-8839-41f3c8829587.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFbnBhZiK24ARWgQBCH44Qh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c912b9cd-880f-4fd9-83a0-5190b2efc86e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Frontwave Arena",
      "poi_type": "Entertainment",
      "poi_address": "3475 Hero Dr, Oceanside, CA 92056, USA",
      "poi_short_description": "New, clean venue for concerts, sporting events and family shows, plus food stalls, patios and lounges. Friendly staff.",
      "poi_long_description": "People say this arena offers a variety of events, including concerts, sports games, and graduations. They also highlight the easy navigation, good sound, and convenient parking.\n\nSome reviews mention the drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-eccc-7149-a4b0-81536454de0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-eccc-7149-a4b0-81536454de0b",
        "storage_key": "property/6767906449167025/019d08bc-eccc-7149-a4b0-81536454de0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://frontwavearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5858338319447952895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontwave-arena",
      "poi_latitude": "33.2076031",
      "poi_longitude": "-117.3147471",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 760-512-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaRb-nVx3IAR_w3BqKn_TFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_90374a3d-4911-42cf-8fa4-e6b4c6bddf44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Boomers Vista",
      "poi_type": "Entertainment",
      "poi_address": "1525 W Vista Way, Vista, CA 92083, USA",
      "poi_short_description": "National amusement center chain featuring mini-golf, go-karts, bumper boats & arcade games.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including go-karts, mini golf, bumper boats, laser tag, and arcade games. They also highlight the friendly and attentive staff, and the clean and well-maintained facilities.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-37a6-7091-86ed-d0aab0822c17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-37a6-7091-86ed-d0aab0822c17",
        "storage_key": "property/6767906449167025/019d08bc-37a6-7091-86ed-d0aab0822c17.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.boomersvista.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5379913675029617691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boomers-vista",
      "poi_latitude": "33.191983",
      "poi_longitude": "-117.2737657",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 760-457-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqxwMm1Zx3IARGxxowvtKqUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6a3e8e80-c635-437a-9252-54bac9f996dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "6133 Innovation Way STE 102, Carlsbad, CA 92009, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities for all ages, including trampolines, ninja courses, and a free fall jump. They highlight the affordable monthly membership, which includes discounts on concessions, and the family-friendly vibe with clean Disney music. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-f141-7739-93c4-65c6260c8a6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-f141-7739-93c4-65c6260c8a6b",
        "storage_key": "property/6767906449167025/019d08bc-f141-7739-93c4-65c6260c8a6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyzone.com/carlsbad/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8802172573593587502&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "33.1282781",
      "poi_longitude": "-117.2602847",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 858-400-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKeS4EBl13IARLk-73FGZJ3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ecc60916-8d89-44e8-885e-b2cfd8e7659d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Wave Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "101 Wave Dr, Vista, CA 92083, USA",
      "poi_short_description": "Park with a pool, water slide, simulated wave attraction & lazy river plus an area for small kids.",
      "poi_long_description": "Park with a pool, water slide, simulated wave attraction & lazy river plus an area for small kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-f1b7-726c-a57f-4160702d3c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-f1b7-726c-a57f-4160702d3c4b",
        "storage_key": "property/6767906449167025/019d08bc-f1b7-726c-a57f-4160702d3c4b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.thewavewaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16628876129709947343&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wave-waterpark",
      "poi_latitude": "33.199225",
      "poi_longitude": "-117.2464486",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 760-940-9283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6MWKaJ23IARz3lVhbyixeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_66461512-2b2a-49d6-a43f-ec181cf172d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "LEGOLAND California Water Park",
      "poi_type": "Entertainment",
      "poi_address": "1 Legoland Dr, Carlsbad, CA 92008, USA",
      "poi_short_description": "Amusement park with a water park featuring a lazy river and wave pool, plus a restaurant.",
      "poi_long_description": "People say this water park offers a variety of water slides, a lazy river, and a wave pool. They also highlight the fun, family-friendly vibe and the convenient amenities, such as lockers and cabanas.\n\nOther reviews mention the crowds can be large.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-f502-7203-a4b7-b092986b7e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-f502-7203-a4b7-b092986b7e0a",
        "storage_key": "property/6767906449167025/019d08bc-f502-7203-a4b7-b092986b7e0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.legoland.com/california/things-to-do/water-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8608451049329350395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legoland-california-water-park",
      "poi_latitude": "33.1288414",
      "poi_longitude": "-117.3136712",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-690-5346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF9m2-6Vz3IAR-1adrZ5cd3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_dff9eeb8-d2f9-408f-93f7-8b2e69c5f5ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3533 Cannon Rd, Oceanside, CA 92056, USA",
      "poi_short_description": "Fitness center chain offering group fitness classes, personal training, and a swimming pool, plus a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a pool, sauna, and massage chairs. They also highlight the clean facilities, friendly and helpful staff, and motivating atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-f5a4-748b-bf03-cec8267f26ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-f5a4-748b-bf03-cec8267f26ba",
        "storage_key": "property/6767906449167025/019d08bc-f5a4-748b-bf03-cec8267f26ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/oceanside-palm-tree-plaza/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396170227420367147&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.1725708",
      "poi_longitude": "-117.2540396",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 760-683-8022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS1ieTXp13IARKwnuUDsM40o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_afe36e54-c2ab-4ce7-8315-58d313741d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2335 Vista Way, Oceanside, CA 92054, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, and group classes, and is spacious and clean.\n\nOther reviews mention the pool can be crowded and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-fb52-726c-b766-a30d0c1f316f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-fb52-726c-b766-a30d0c1f316f",
        "storage_key": "property/6767906449167025/019d08bc-fb52-726c-b766-a30d0c1f316f.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=702&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17000514346618706610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.1827529",
      "poi_longitude": "-117.33649",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 760-576-3188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdc5_F41x3IARstojxbn17es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e9194b56-7069-4ec1-a240-4b0373818249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 El Camino Real, Carlsbad, CA 92008, USA",
      "poi_short_description": "Chain fitness center in The Shoppes at Carlsbad offering cardio and weight equipment, classes, and a swimming pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-027a-77bc-a3be-d64ea3574167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-027a-77bc-a3be-d64ea3574167",
        "storage_key": "property/6767906449167025/019d08bd-027a-77bc-a3be-d64ea3574167.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/carlsbad-ca/carlsbad-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=13342129328025537868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "33.1788378",
      "poi_longitude": "-117.3288756",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 760-439-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-AdgjmC4xQRTI1IKO_DKLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_547fb646-ff8a-4002-a9bb-25f2c49e461a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4130 Oceanside Blvd, Oceanside, CA 92056, USA",
      "poi_short_description": "Chain gym providing a variety of workout equipment, plus tanning and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-4912-7190-aec3-ca12693bc61d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-4912-7190-aec3-ca12693bc61d",
        "storage_key": "property/6767906449167025/019d08bc-4912-7190-aec3-ca12693bc61d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oceanside-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2573509955116400673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.20735",
      "poi_longitude": "-117.28888",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 760-941-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYPYmD9x3IARIQClTKvxtiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87d1403d-d5be-4869-82c7-26344a123a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "VCA California Veterinary Specialists-Carlsbad",
      "poi_type": "Health and Wellness",
      "poi_address": "2310 Faraday Ave, Carlsbad, CA 92008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-0423-763d-b17c-223ba906afac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-0423-763d-b17c-223ba906afac",
        "storage_key": "property/6767906449167025/019d08bd-0423-763d-b17c-223ba906afac.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/california-veterinary-specialists-carlsbad?utm_source=maps&utm_medium=organic&utm_campaign=AU_1142",
      "poi_directions_map_url": "https://maps.google.com/?cid=17795725608930145556&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-california-veterinary-specialists-carlsbad",
      "poi_latitude": "33.13598440000001",
      "poi_longitude": "-117.2763446",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 760-431-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8oe1WRz3IARFHWa0Cce9_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9d7e4e4f-cb8b-47a7-b55e-9d8489bd0f1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Joe and Mary Mottino Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "4701 Mesa Dr, Oceanside, CA 92056, USA",
      "poi_short_description": "Community center with a gym, swimming pool, classes for all ages, and childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-03bd-731c-9271-a6ab7b8dc2ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-03bd-731c-9271-a6ab7b8dc2ef",
        "storage_key": "property/6767906449167025/019d08bd-03bd-731c-9271-a6ab7b8dc2ef.webp",
        "width": 820,
        "height": 340
      },
      "poi_business_url": "https://www.ymcasd.org/locations/joe-and-mary-mottino-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9934014182364602791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joe-and-mary-mottino-family-ymca",
      "poi_latitude": "33.2249026",
      "poi_longitude": "-117.290987",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 760-758-0808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVUtHyBx3IARp-GIJUS13Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7efa412f-8737-4a29-aaef-56ad3d6a5ba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Banfield Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "471-2 College Blvd, Oceanside, CA 92057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-09e6-751d-97ce-ba5a7d5112e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-09e6-751d-97ce-ba5a7d5112e7",
        "storage_key": "property/6767906449167025/019d08bd-09e6-751d-97ce-ba5a7d5112e7.webp",
        "width": 684,
        "height": 514
      },
      "poi_business_url": "https://www.banfield.com/locations/veterinarians/ca/oceanside/osd?utm_source=yext&utm_medium=yext&utm_campaign=yext&cid=yext_local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10395750650327262689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banfield-pet-hospital",
      "poi_latitude": "33.2443647",
      "poi_longitude": "-117.2915248",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 760-639-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVadKcBw3IAR4eVKLiMgRZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0394abb3-6bcd-42e1-94a8-d415ea1b93e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Tri-City Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4002 Vista Way, Oceanside, CA 92056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-4269-739b-aa51-ce224c9270da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-4269-739b-aa51-ce224c9270da",
        "storage_key": "property/6767906449167025/019d08bc-4269-739b-aa51-ce224c9270da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tricitymed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10784617143073185396&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tri-city-medical-center",
      "poi_latitude": "33.1856641",
      "poi_longitude": "-117.2903662",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 760-724-8411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-8de7-7578-966d-58a91d228dda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-8de7-7578-966d-58a91d228dda",
        "storage_key": "property/6767906449167025/019d08bc-8de7-7578-966d-58a91d228dda.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yPO8GFx3IARdB53-yaoqpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d5449e70-bb4c-481e-ac7b-270f852bf368",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Scripps Medical Center Jefferson",
      "poi_type": "Health and Wellness",
      "poi_address": "2205 Vista Way Ste 110, Oceanside, CA 92054, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-0a95-71d5-8573-83bd35b760b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-0a95-71d5-8573-83bd35b760b2",
        "storage_key": "property/6767906449167025/019d08bd-0a95-71d5-8573-83bd35b760b2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.scripps.org/locations/specialty-centers/scripps-medical-center-jefferson?tab=overview",
      "poi_directions_map_url": "https://maps.google.com/?cid=5358663324360325750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scripps-medical-center-jefferson",
      "poi_latitude": "33.1825738",
      "poi_longitude": "-117.3385665",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 760-280-7464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-8de7-7578-966d-58a91d228dda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-8de7-7578-966d-58a91d228dda",
        "storage_key": "property/6767906449167025/019d08bc-8de7-7578-966d-58a91d228dda.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE62753xx3IARdjpp7-bLXUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2bdfebd6-b3f0-497a-baba-a31ccdf0889f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Arrowood Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5201 Village Dr, Oceanside, CA 92057, USA",
      "poi_short_description": "Hilltop 18-hole golf course with a driving range, putting greens, large clubhouse, grill & shop.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with well-maintained fairways, pristine greens, and stunning views. They highlight the smooth pace of play, the excellent driving range with free shot tracker, and the comfortable carts with GPS and speakers. They also like the friendly and professional staff, and the great food and drinks at the restaurant and bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-0b97-7359-8454-939c11d89987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-0b97-7359-8454-939c11d89987",
        "storage_key": "property/6767906449167025/019d08bd-0b97-7359-8454-939c11d89987.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "http://arrowoodgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9964713419880956462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arrowood-golf-course",
      "poi_latitude": "33.2731854",
      "poi_longitude": "-117.2875979",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 760-967-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-2ee0-7409-89c3-24b34d32fb3b",
        "storage_key": "property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-486jaBw3IARLoKSYA_GSYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7316d0d2-552e-49c8-b590-9c900980b36d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Alga Norte Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6565 Alicante Rd, Carlsbad, CA 92009, USA",
      "poi_short_description": "Roomy park featuring a basketball court, baseball fields & picnic areas with barbecues.",
      "poi_long_description": "People say this park offers a variety of fun activities, including a playground, skate park, swimming pools, and a dog park. They highlight the park's expansive and unique playground, and the availability of amenities like a splash pad, soccer and baseball fields, and batting cages. They also like the family-friendly atmosphere and the well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-0ba2-717a-adf9-38aa727fdf4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-0ba2-717a-adf9-38aa727fdf4a",
        "storage_key": "property/6767906449167025/019d08bd-0ba2-717a-adf9-38aa727fdf4a.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.carlsbadca.gov/Home/Components/FacilityDirectory/FacilityDirectory/10/7417",
      "poi_directions_map_url": "https://maps.google.com/?cid=121978627706803562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alga-norte-community-park",
      "poi_latitude": "33.1163192",
      "poi_longitude": "-117.2634522",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 760-434-2826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-8bb4-74e8-9759-9a1bc4f4f64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-8bb4-74e8-9759-9a1bc4f4f64d",
        "storage_key": "property/6767906449167025/019d08bc-8bb4-74e8-9759-9a1bc4f4f64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiegML6l03IARalWnZupasQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_da2189a0-f468-4dc3-98e9-f0869307e80c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "The Crossings at Carlsbad",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5800 The Crossings Dr, Carlsbad, CA 92008, USA",
      "poi_short_description": "Upscale golf club with an 18-hole course & a posh, water-view restaurant, popular for weddings.",
      "poi_long_description": "People say this golf course offers a challenging layout with incredible views and vistas. They highlight the excellent facilities, amenities, and well-maintained course, as well as the delicious food and breathtaking sunset views. They also like the friendly, helpful, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1122-72fc-98e6-48972733ba6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1122-72fc-98e6-48972733ba6b",
        "storage_key": "property/6767906449167025/019d08bd-1122-72fc-98e6-48972733ba6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thecrossingsatcarlsbad.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9237206923664344602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-crossings-at-carlsbad",
      "poi_latitude": "33.128682",
      "poi_longitude": "-117.305711",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 760-444-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-2ee0-7409-89c3-24b34d32fb3b",
        "storage_key": "property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0ex7BFz3IARGsbKmcEmMYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_aa56fb67-30ba-41c0-b8c8-13c8010f542d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Twin Oaks Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1425 N Twin Oaks Valley Rd, San Marcos, CA 92069, USA",
      "poi_short_description": "Scenic golf course with a driving range, pro shop, pub with a patio & 225-capacity events venue.",
      "poi_long_description": "Scenic golf course with a driving range, pro shop, pub with a patio & 225-capacity events venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1310-7542-9987-a4b40f111741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1310-7542-9987-a4b40f111741",
        "storage_key": "property/6767906449167025/019d08bd-1310-7542-9987-a4b40f111741.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jcgolf.com/san-diego-golf-courses/twin-oaks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13340062029559646280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "twin-oaks-golf-course",
      "poi_latitude": "33.1648383",
      "poi_longitude": "-117.1588671",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 760-591-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-2ee0-7409-89c3-24b34d32fb3b",
        "storage_key": "property/6767906449167025/019d08bd-2ee0-7409-89c3-24b34d32fb3b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_goHI6K24ARSEiUubxrIbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_6db26772-bddd-4083-a204-b6173f8113aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Aviara Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6435 Ambrosia Ln, Carlsbad, CA 92011, USA",
      "poi_short_description": "24-acre community park features athletic turf fields & courts, a playground & lighted picnic areas.",
      "poi_long_description": "People say this park offers soccer fields, baseball fields, basketball courts, a playground, and picnic areas. They highlight the spacious layout, clean restrooms, and beautiful views. They also like the well-maintained facilities and the variety of activities available for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1311-70ef-9746-98b8154201a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1311-70ef-9746-98b8154201a1",
        "storage_key": "property/6767906449167025/019d08bd-1311-70ef-9746-98b8154201a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.carlsbadca.gov/Home/Components/FacilityDirectory/FacilityDirectory/26/7400",
      "poi_directions_map_url": "https://maps.google.com/?cid=14058683201250719969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aviara-community-park",
      "poi_latitude": "33.1150075",
      "poi_longitude": "-117.2813025",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 442-339-2690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-8bb4-74e8-9759-9a1bc4f4f64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-8bb4-74e8-9759-9a1bc4f4f64d",
        "storage_key": "property/6767906449167025/019d08bc-8bb4-74e8-9759-9a1bc4f4f64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95wWmEVz3IAR4fhMrOJ5GsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a22cfbb5-bf06-40c4-bb44-93b7a0a5cf6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "McClellan-Palomar Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2198 Palomar Airport Rd, Carlsbad, CA 92008, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this airport offers convenient commercial flights, charter jet services, and a restaurant with live music. They highlight the airport's small size, efficient service, and relaxed atmosphere, as well as the easy access and parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1333-70ea-b390-8625518b7a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1333-70ea-b390-8625518b7a8e",
        "storage_key": "property/6767906449167025/019d08bd-1333-70ea-b390-8625518b7a8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.sdcounty.ca.gov/dpw/airports/palomar.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17905321001156734788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcclellan-palomar-airport",
      "poi_latitude": "33.1278998",
      "poi_longitude": "-117.2791928",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 760-431-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-959e-758e-a603-4beca287d959.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-959e-758e-a603-4beca287d959",
        "storage_key": "property/6767906449167025/019d08bc-959e-758e-a603-4beca287d959.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bWM0mdz3IARRO9Jh5V6fPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_fb0d2795-5fd6-4313-a511-3dc4938518a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Vista Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Vista, CA 92083, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-193f-7748-b9cd-edde520f899b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-193f-7748-b9cd-edde520f899b",
        "storage_key": "property/6767906449167025/019d08bd-193f-7748-b9cd-edde520f899b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=943456310329078819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vista-transit-center",
      "poi_latitude": "33.2028923",
      "poi_longitude": "-117.2449411",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwnneqJ23IARI_RD_oPUFw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_14e44779-28f8-4f10-a501-b42e9f931ddf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Carlsbad Airport Centre",
      "poi_type": "Transportation & Transit",
      "poi_address": "5857 Owens Ave, Carlsbad, CA 92008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1b23-76fa-a8cb-dfea8c5b2f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1b23-76fa-a8cb-dfea8c5b2f1e",
        "storage_key": "property/6767906449167025/019d08bd-1b23-76fa-a8cb-dfea8c5b2f1e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109997952778039368&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carlsbad-airport-centre",
      "poi_latitude": "33.1205054",
      "poi_longitude": "-117.2824076",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-959e-758e-a603-4beca287d959.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-959e-758e-a603-4beca287d959",
        "storage_key": "property/6767906449167025/019d08bc-959e-758e-a603-4beca287d959.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3iLoENz3IARSPDSTGHI0MM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d5119af4-205d-4930-8f6e-b3d87df3359c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Palomar College Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Marcos, CA 92069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1b56-76fe-91d7-31107aecdbe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1b56-76fe-91d7-31107aecdbe4",
        "storage_key": "property/6767906449167025/019d08bd-1b56-76fe-91d7-31107aecdbe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8640663605884310252&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palomar-college-station",
      "poi_latitude": "33.1468346",
      "poi_longitude": "-117.1851389",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdLTqkJ13IAR7FJh9MTN6Xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c622d9c9-c663-4584-95c0-24d999168cec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Buena Creek Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Vista, CA 92084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-672e-747f-829e-b2c61b36f36e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-672e-747f-829e-b2c61b36f36e",
        "storage_key": "property/6767906449167025/019d08bc-672e-747f-829e-b2c61b36f36e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855954247126349543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buena-creek-station",
      "poi_latitude": "33.1735696",
      "poi_longitude": "-117.2074047",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2X0Xtrp13IAR5_YHzPk8SsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_d01ed745-78cd-4d86-abee-478f3a470a8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Viasat",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6155 El Camino Real, Carlsbad, CA 92009, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-1d73-711a-a2b3-d058dadf571a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1d73-711a-a2b3-d058dadf571a",
        "storage_key": "property/6767906449167025/019d08bd-1d73-711a-a2b3-d058dadf571a.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.viasat.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14353962451294785354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "viasat",
      "poi_latitude": "33.1268755",
      "poi_longitude": "-117.266946",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 855-578-1206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5eo619z3IARSo-4hMyEM8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e960939b-bd9e-449e-a32f-262ff0db9dd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Callaway Golf Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2180 Rutherford Rd, Carlsbad, CA 92008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-23c7-7258-b0fc-e332c2876903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-23c7-7258-b0fc-e332c2876903",
        "storage_key": "property/6767906449167025/019d08bd-23c7-7258-b0fc-e332c2876903.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.callawaygolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15883702568930767396&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "callaway-golf-co",
      "poi_latitude": "33.1318233",
      "poi_longitude": "-117.2806578",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 760-931-1771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgRvqHRVz3IARJPITu1Q_btw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3563af47-ec52-46e2-adb6-1338701ba251",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Alphatec Spine, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1950 Camino Vida Roble, Carlsbad, CA 92008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://atecspine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467469144690544300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alphatec-spine-inc",
      "poi_latitude": "33.1228816",
      "poi_longitude": "-117.2832261",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 760-431-9286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0ABP2Nz3IARrE7QWNUP5ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ddb27832-9c1d-4fd6-957b-ace89ecf49de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Leica Biosystems (Aperio)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1360 Park Center Dr, Vista, CA 92081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-224b-77f9-b8ec-e2dc2d10c924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-224b-77f9-b8ec-e2dc2d10c924",
        "storage_key": "property/6767906449167025/019d08bd-224b-77f9-b8ec-e2dc2d10c924.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leicabiosystems.com/digital-pathology/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12554160172958647295&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "leica-biosystems-aperio",
      "poi_latitude": "33.1401507",
      "poi_longitude": "-117.2396098",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-478-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Zrbex03IAR_4OOmilWOa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_761b644c-ae2b-4139-8da3-140035299a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "poi_name": "Bandy Ranch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2755 Dos Aarons Way # C, Vista, CA 92081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bd-240f-76ae-b721-90ffbc595428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-240f-76ae-b721-90ffbc595428",
        "storage_key": "property/6767906449167025/019d08bd-240f-76ae-b721-90ffbc595428.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bandyranchfloral.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10308617929323313494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bandy-ranch",
      "poi_latitude": "33.1450532",
      "poi_longitude": "-117.2311226",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 760-295-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-7ddb-77fb-957f-3ac1d42be2c7",
        "storage_key": "property/6767906449167025/019d08bc-7ddb-77fb-957f-3ac1d42be2c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzyJa-V03IARVvmJqmORD48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0519362b37c6243f453a7d62",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_56d086b69ea3d06d6380db7c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_238b685a95d6e37ff0c839b2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_d6d2b0524c1e8586600770e6",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "12:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a87b7310-43b3-4c58-860a-240163eebeed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5.0",
      "name": "Diana Cannizzaro",
      "text": "I love living here! dog friendly , good neighbors,  quiet,  the only noise came  from out side cars, because is located in downtown ,  little city , you can walk to bars and restaurants...",
      "date": "2025-11-14",
      "title": ""
    },
    {
      "id": "custom_81706d37-3024-4901-9a68-722c30105932",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5.0",
      "name": "Joyce McGill",
      "text": "The Property Manager was very helpful and informative.  She was most gracious and provided us with the information that we needed. We look forward to becoming members of the community.",
      "date": "2026-02-18",
      "title": ""
    },
    {
      "id": "custom_a1c5c02e-905b-4b53-863e-1caf662a4858",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5.0",
      "name": "RUBI CARRASCO",
      "text": "As a resident of Creekside Apartments, I'm glad to see management taking proactive steps regarding the homeless individual near the creek. Even though he's not on the property, they've hired a security guard and set up cameras for our safety. Though law enforcement couldn't help due to no criminal activity, I appreciate management's quick action. Here's hoping the situation gets resolved soon. Thanks for looking out for us!",
      "date": "2024-03-12",
      "title": ""
    },
    {
      "id": "custom_6f168afd-9011-4c1f-9a75-7b4a1e6df27c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "4.0",
      "name": "Ronald Hochstein",
      "text": "You are keeping the complex clean and secure. Excellent response on maintenance and follow up\n.",
      "date": "2026-01-10",
      "title": ""
    },
    {
      "id": "custom_3d35f596-66bc-4be4-84c4-97b04d02284c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5",
      "name": " Mia Suffredini",
      "text": "Loved Ashlie! She was very sweet and I am very excited to hopefully call this place my next home!",
      "date": "2026-10-17",
      "title": "false"
    },
    {
      "id": "custom_d540c341-fcd1-408d-92ce-634ffd6359a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5",
      "name": " Joyce McGill",
      "text": "The Property Manager was very helpful and informative. She was most gracious and provided us with the information that we needed. We look forward to becoming members of the community.",
      "date": "2026-10-19",
      "title": "false"
    },
    {
      "id": "custom_b9f73d7b-80a6-41c1-a45d-8dd447d5a0e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5",
      "name": "Ronald Hochstein",
      "text": "You are keeping the complex clean and secure. Excellent response on maintenance and follow up\n",
      "date": "2026-02-18",
      "title": "false"
    },
    {
      "id": "custom_c5bfa434-892b-44e8-83b6-9e493295a7c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "rating": "5",
      "name": "Diana Cannizzaro",
      "text": "I love living here! dog friendly , good neighbors, quiet, the only noise came from out side cars, because is located in downtown , little city , you can walk to bars and restaurants...\n",
      "date": "2025-12-18",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4cba5089-2cdd-429b-b16f-2c0507b24b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d45fe-8774-70df-96b1-e5fea3d2fa6c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fe-8774-70df-96b1-e5fea3d2fa6c",
        "storage_key": "property/6767906449167025/019d45fe-8774-70df-96b1-e5fea3d2fa6c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Apartments - Model 2 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cRao8VLSJ19"
    },
    {
      "id": "custom_4e706287-4ce2-40a6-bff1-a0208e25a556",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d45fe-9906-773b-9b0c-ae17d23148e8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fe-9906-773b-9b0c-ae17d23148e8",
        "storage_key": "property/6767906449167025/019d45fe-9906-773b-9b0c-ae17d23148e8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Apartments - 1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jkZcVSWKJhi"
    },
    {
      "id": "custom_2ea68a26-17c6-4066-b605-837a0a9c51b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d45fe-accf-720a-bf34-8887a47388a2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fe-accf-720a-bf34-8887a47388a2",
        "storage_key": "property/6767906449167025/019d45fe-accf-720a-bf34-8887a47388a2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Apartments - 2 Bedroom 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZXmdCaaVT8A&brand=0"
    },
    {
      "id": "custom_d3a837c5-dcce-456e-b072-782b26f30dd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167025/019d45fe-d12e-743d-ba2e-75ae203b2a77.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fe-d12e-743d-ba2e-75ae203b2a77",
        "storage_key": "property/6767906449167025/019d45fe-d12e-743d-ba2e-75ae203b2a77.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Apartments",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vTNqyT79ucw"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ecc2c-6354-773d-874a-03bf0b56c7a5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Vista Creekside  Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167025"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5731"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18224252604"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WK43G5FN"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.creeksideapartmentsvista.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncdn.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1219288\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "42176974715"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn1y58pd2"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "00927850"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlA1RHUrRFV5cG9jV2ZsRzhvYWFJeEE9PSIsInZhbHVlIjoicS9NT2lxVm5JMkxTdzExdi9XWmZ3UT09IiwibWFjIjoiNmRmOTgxNDVmMjAwNGFlNWYzZjJlNmRiZjE1YWI3YWZjOGU5YmI2ZjQyNDNlNzA2MDI4ODRlNTJkNzUyZmMzMyJ9"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5731",
  "custom_repli_id": "18224252604",
  "custom_google_gtm_id": "GTM-WK43G5FN",
  "custom_entrata_chatbot": "<script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.creeksideapartmentsvista.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncdn.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1219288\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "42176974715",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn1y58pd2",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "00927850",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlA1RHUrRFV5cG9jV2ZsRzhvYWFJeEE9PSIsInZhbHVlIjoicS9NT2lxVm5JMkxTdzExdi9XWmZ3UT09IiwibWFjIjoiNmRmOTgxNDVmMjAwNGFlNWYzZjJlNmRiZjE1YWI3YWZjOGU5YmI2ZjQyNDNlNzA2MDI4ODRlNTJkNzUyZmMzMyJ9",
  "custom_audioeye_site_id": "10b8bca5-84c6-464a-bc4f-72df6358354b",
  "custom_audioeye_site_hash": "f3ef63c96c138c0b45af99c71e92315e"
};

export const generatedAt = '2026-10-19T18:12:21.929Z';
